<app-header></app-header>

<section class="bredcrumb bg-grey">
    <div class="container">
        <ul class="brd-nav">
       
            <li> <span> {{ title }} </span></li>
        </ul>
    </div>
</section>
<!--- End of bredcrumb --->

<section class="partner-blog  bg-grey padd-row">
    <div class="container">
        <div class="parnter-blog-main articles-main">
            <!-- <div class="partner-blog-nav">
                
             <ul class="nav nav-pills">
                <li class="nav-item">
                     <a class="nav-link active btn-style" data-toggle="pill" href="#yoga"> Yoga </a>
                </li>
               <li class="nav-item">
                   <a class="nav-link btn-style" data-toggle="pill" href="#health"> Health </a>
               </li> 
             </ul>   
            </div> -->
            <div class="parnter-blog-boxes">
              <!-- Tab panes -->
             <div class="tab-content">
               <div class="tab-pane active" id="yoga">
                    <div class="row">
                            <div *ngFor="let article of articles" class="col-md-4">
                                <div class="partner-blog-box" >
          
                              
                                <a class="partner-blog-box-topanchor" [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                  
                                      <div class="blog-box-img">
                                          <img [src]="article.image" alt="blog-box">
                                         
                                      </div>
                                      <div class="blog-box-cnt">
                                          <h4> {{ article.title }} </h4>
                                          <!-- <p [innerHTML]="article.text.slice(0,25)">  </p> -->
                                         
                                      </div>
                                 
                              </a>
                              <a  class="partner-blog-box-downanchor" [routerLink]="['/doctors/detail/'+article?.doctorId?.uniquekey]"><b>{{ article?.doctorId?.name ? 'By '+ article?.doctorId?.name : ''  }}</b></a>
                          </div>
                              </div>
                             
                          </div>
                .</div>
               <!-- <div class="tab-pane fade" id="health">
                    <div class="row">
                            <div *ngFor="let article of healthArticles" class="col-md-4">
                                <div class="partner-blog-box" >
          
                              
                                <a class="partner-blog-box-topanchor" [routerLink]="['/blog-detail/'+article._id]">
                                  
                                      <div class="blog-box-img">
                                          <img [src]="article.image" alt="blog-box">
                                         
                                      </div>
                                      <div class="blog-box-cnt">
                                          <h4> {{ article.title }} </h4>
                                          <p [innerHTML]="article.text.slice(0,25)">  </p>
                                         
                                      </div>
                                 
                              </a>
                              <a class="partner-blog-box-downanchor" [routerLink]="['/doctors/detail/'+article?.doctorId?._id]"><b>{{ article?.doctorId?.name ? 'By '+ article?.doctorId?.name : ''  }}</b></a>
                          </div>
                              </div>
                             
                          </div>
                .</div>  -->
           </div>




                
            </div>
        </div>
    </div>
</section>